export const getClientIsWorkingContent = (isWorking: boolean): { tooltipText: string; label: string } => {
  return {
    tooltipText: isWorking
      ? 'Включите «Не работаю», тогда при поиске вас не увидят в выдаче. Если статус в режиме «Работаю», то ваша анкета видна в выдаче.'
      : 'Включите «Работаю», тогда при поиске вас увидят в выдаче. Если статус в режиме «Не работаю», то в выдаче вас не видно.',
    label: isWorking ? 'Работаю' : 'Не работаю',
  };
};
